// extracted by mini-css-extract-plugin
module.exports = {"item":"businessarealist_item__TdUrB"};